export default __webpack_public_path__ + "static/media/precious.8c2ac6df.png";